import { Typography } from '@la/ds-ui-components';
import { getSiteId, useAppSelector } from '@la/services';
import { Activity } from '@la/types';
import { getLAHostnameParts } from '@la/utilities';
import {
  // useGetProgramSettingsQuery,
  useGetSingleActivityRosterQuery,
} from 'redux/services/singleActivityApi';
import { useGetTeamQuery } from 'redux/services/teamApi';
import { UserSummary } from 'redux/services/types/singleActivity';
import styles from '../SingleActivityViewSidePanel.module.scss';

export default function ActivityMatchup({
  activity,
  userSummaries,
}: {
  activity?: Activity;
  userSummaries: UserSummary[];
}) {
  const { subdomain } = getLAHostnameParts();
  const siteId = useAppSelector(getSiteId) ?? '';

  //TODO: test if this is needed
  // const { data: programSetting } = useGetProgramSettingsQuery(
  //   {
  //     subdomain,
  //     programId: activity?.programId ?? 0,
  //   },
  //   {
  //     skip: !activity,
  //   }
  // );
  // const rosterVisibility = programSetting?.settings.rosterVisibility;

  const teamId = userSummaries[0]?.teamIds?.[0];

  const { data: team } = useGetTeamQuery(
    {
      siteDomain: subdomain,
      teamId: teamId ? teamId.toString() : '0',
    },
    { skip: !teamId }
  );

  const { data: roster } = useGetSingleActivityRosterQuery(
    {
      subdomain,
      siteId,
      teamId: userSummaries?.length
        ? userSummaries[0].teamIds[0].toString()
        : '0',
    },
    {
      skip: !userSummaries,
    }
  );

  const getInitials = (name: string): string => {
    const n = name.split(' ');
    return `${n[0].split('')[0]}${n[n.length - 1].split('')[0]}`;
  };

  return (
    <div className={styles.matchUpContainer}>
      <Typography variant="ui" size="large">
        {team?.name}
      </Typography>
      {roster?.roster.map((user, idk) => {
        return (
          <div className={styles.rosterContainer} key={idk}>
            <div className={styles.avatar}>{getInitials(user.name)}</div>

            <div className={styles.staffInfo}>
              <Typography variant="ui" size="medium" weight="bold">
                {user.name}
              </Typography>
              <Typography variant="ui" size="medium" weight="regular">
                {user.role}
              </Typography>
            </div>
          </div>
        );
      })}
    </div>
  );
}
